<div class="instruction-search__container"
    [ngClass]="{'desktop': !mobile}">
    <div class="instruction-search__content">
        <mat-icon>search</mat-icon>
        <div class="instruction-search-input__container">
            <input id="instruction-search-input"
                placeholder="{{ 'default.quickSearch' | blah }}"
                [formControl]="searchValue"
                (focus)="focus()"
                (blur)="blur()"
                (keydown.enter)="closeKeyboard($event)"
                type="text" />
            @if (searchValue.value) {
                <span class="count">{{currentIndex + 1}}/{{matches.length}}</span>
            }
        </div>

        @if (isFocused || searchValue.value) {
            <div style="width: 1px; height: 30px; background: #e0e0e0;"></div>
            <button class="instruction-search__button"
                (click)="previous()"
                [disabled]="!matches.length || !searchValue.value.length">
                <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
            <button class="instruction-search__button"
                (click)="next()"
                [disabled]="!matches.length || !searchValue.value.length">
                <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
            <button class="instruction-search__button"
                (click)="resetSearch()"
                [disabled]="!matches.length && !searchValue.value.length">
                <mat-icon>close</mat-icon>
            </button>
        }
    </div>
</div>